import { HttpMethod } from "../Common/useFetch";
import { RequestOptions } from "../Common/useRequest";
import useUserRequest, { UserRequestSpec } from "../Common/useUserRequest";
import { useSelectedBusiness } from "../UserAccess/useSelectedBusiness";
const useDeclineConnection = (code: string, options?: RequestOptions<void>) => {
  const business = useSelectedBusiness();
  const spec: UserRequestSpec = {
    path: `/api/businesses/${business.id}/dataSharing/codes/${code}/decline`,
    method: HttpMethod.POST,
  };

  return useUserRequest<void, void>(spec, options);
}

export default useDeclineConnection;